import { Alert, Flex, Modal, Select, Space, Table, Tag, theme, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { LEGALBASIS_OPTIONS, PRIVACY_STRING_CHANGE_NAT_TO_STATE_TOOLTIP, PRIVACY_STRING_CHANGE_STATE_TO_NAT_TOOLTIP, PRIVACY_STRING_TOOLTIP, renderInfoTip, StateCodeRender } from "../../../helper";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

const { Text, Paragraph } = Typography;

const BulkRegionMappingModal = (props) => {
  const [categories, setCategories] = useState(_.cloneDeep(props.categories));
  const [privacySignalConfigByGeo, setPrivacySignalConfigByGeo] = useState(_.cloneDeep(props.privacySignalConfigByGeo));
  const [dataSource, setDataSource] = useState(_.cloneDeep(props.selectedRegions.map((data) => ({...data, updateStatus: {}}))));
  const [modal, contextHolder] = Modal.useModal();
  const { token } = theme.useToken();

  const legalOptionsValueToLabel = LEGALBASIS_OPTIONS.reduce((acc, next) => {
    acc[next.value] = next.label;
    return acc;
  },{})

  async function handlePrivacySignalUpdate(bulkPrivacySignal) {
    let confirmation = true;
    let modalContent = bulkPrivacySignal === "usnat" ? PRIVACY_STRING_CHANGE_STATE_TO_NAT_TOOLTIP : PRIVACY_STRING_CHANGE_NAT_TO_STATE_TOOLTIP;
    
    if(!props.isNoFrameworkFlow && !(props.previousLegislation === "usnat" && bulkPrivacySignal === "usnat")) {
      confirmation = await modal.confirm({
        title:"Consent Update",
        content: modalContent,
        okText: "Apply",
        width: 500,
      })
    }
    if(confirmation) {
      setPrivacySignalConfigByGeo(prevConfig => {
        const newConfig = {...prevConfig}; // Create a new object with spread
        dataSource.forEach(({region}) => {
          newConfig[region] = {legislation: bulkPrivacySignal}
        })
        return newConfig; // Return the new object
      });
      setCategories((categories) => categories.map((cat) => {
        setDataSource((dataSource) => dataSource.map(data => {
          if(privacySignalConfigByGeo[data.region]?.legislation !== "usnat" && bulkPrivacySignal === "usnat") {
            delete cat.configByGeo[data.region];
          } else if(privacySignalConfigByGeo[data.region]?.legislation !== "state" && bulkPrivacySignal === "state"){
            let iabConfigGeo = props.getIabDefinedConfigGeo(cat, data.region, "state");
            cat.configByGeo[data.region] = iabConfigGeo ?? {defaultLegalBasis: "NOT_APPLICABLE"}
          }
          // data.updateStatus[cat.id] = "success";
          return data;
        }))      
        return cat;
      }))
    }
  }

  async function handleCateogyLegalBasisChagne(categoryId, bulkLegalBasis) {
    if(dataSource.some(({region}) => privacySignalConfigByGeo[region]?.legislation === "usnat") && !props.isNoFrameworkFlow) {
      const confirmation = await modal.confirm({
        title:"Consent Update",
        content: "Since the national string has only one string, we will be applying this consent change to all the regions with National String for this privacy choice. Are you sure you want to go ahead with this change?",
        okText: "Apply",
        width: 500,
      })
      if(!confirmation) {
        return;   
      }
    }
    setCategories((categories) => categories.map((cat) => {
    const isIabCat = cat.type === "SYSTEM_PURPOSE"
      if(cat.id === categoryId) {
        setDataSource((dataSource) => dataSource.map((data) => {
          if(privacySignalConfigByGeo[data.region]?.legislation === "usnat" && !props.isNoFrameworkFlow) {
            props.usnatRegionsToUpdate.forEach((region) => {
              let iabConfigGeo = props.getIabDefinedConfigGeo(cat, region, "usnat");
              const allowedOptions = ["NOT_APPLICABLE"];
              if(isIabCat && iabConfigGeo?.defaultLegalBasis === "OPT-OUT") { 
                allowedOptions.push("CONSENT");
              }
              let avialableOptoins =  isIabCat ? LEGALBASIS_OPTIONS.filter((opt) => iabConfigGeo?.defaultLegalBasis === opt.value || allowedOptions.includes(opt.value)) : LEGALBASIS_OPTIONS;
              if(avialableOptoins.some((opt) => opt.value === bulkLegalBasis)) {
                cat.configByGeo[region] = {defaultLegalBasis: bulkLegalBasis}
                data.updateStatus[categoryId] = "success";
              } else {
                data.updateStatus[categoryId] = "fail"
              }
            })
          } else {
            let iabConfigGeo = props.getIabDefinedConfigGeo(cat, data.region, privacySignalConfigByGeo[data.region]?.legislation);
            const allowedOptions = ["NOT_APPLICABLE"];
            if(isIabCat && iabConfigGeo?.defaultLegalBasis === "OPT-OUT") { 
              allowedOptions.push("CONSENT");
            }
            let avialableOptoins =  isIabCat && !props.isNoFrameworkFlow ? LEGALBASIS_OPTIONS.filter((opt) => iabConfigGeo?.defaultLegalBasis === opt.value || allowedOptions.includes(opt.value)) : LEGALBASIS_OPTIONS;
            if(avialableOptoins.some((opt) => opt.value === bulkLegalBasis)) {
              cat.configByGeo[data.region] = {defaultLegalBasis: bulkLegalBasis}
              data.updateStatus[categoryId] = "success";
            } else {
              data.updateStatus[categoryId] = "fail"
            }
          }
          return data;
        }))
      }
      return cat;
    }))
  }

  function handleSaveChange() {
    props.setCategories(categories);
    props.setPrivacySignalConfigByGeo(privacySignalConfigByGeo);
    props.closeModal();
  }


  useEffect(() => {
    setDataSource((prevDataSource) => {
      return prevDataSource.map((data) => {
        const newData = { ...data };
        categories.forEach((cat) => {
          if (cat.configByGeo) {
            const defLegBasisRecord = privacySignalConfigByGeo[data.region]?.legislation === "usnat" && !props.isNoFrameworkFlow ? cat.configByGeo[data.region?.split("_",1)[0]] : cat.configByGeo[data.region];
            if (defLegBasisRecord) {
              newData.legalBasis = newData.legalBasis || {};
              newData.legalBasis[cat.id] = defLegBasisRecord.defaultLegalBasis;
            }
          }
        });
        newData.privacySignal = privacySignalConfigByGeo[data.region]?.legislation;
        return newData;
      });
    });
  }, [categories, privacySignalConfigByGeo]);

  let privacySignalOptions = [{label: "National", value: "usnat"}];
  if(props.selectedRegions.every(({region}) => props.stateStringRegions[region])) {
    privacySignalOptions.push({label: "State", value: "state"})
  }

  const columns = [
    {
      title: "Region",
      fixed: "left",
      dataIndex: "region",
      width: 200,
      render: (stateCode, record) => {
        return (
          <Flex gap={12} align="center">
            <Text>{record.title}</Text>
            {props.isNoFrameworkFlow ? null : <StateCodeRender stateCode={record.region}/>}
          </Flex>
        );
      },
    }
  ]
  if(!props.isNoFrameworkFlow) {
    columns.push(
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
          <Flex vertical gap={12}>
            <Typography.Text>Privacy String {renderInfoTip(PRIVACY_STRING_TOOLTIP, null, "4px", 800)}</Typography.Text>
            <Select
              onChange={handlePrivacySignalUpdate}
              options={privacySignalOptions}
              style={{minWidth: 150}}
            />
          </Flex>
        )},
        fixed: "left",
        dataIndex: "privacySignal",
        width: 200,
        render: (value, record) => {
          return (
            <Select
              value={value}
              disabled={true}
              options={[{label: "National", value: "usnat"}, {label: "State", value: "state"}]}
              style={{minWidth: 150}}
            />
          )
        }
      }
    )
  }

  categories.forEach((cat) => {
    const isIabCat = cat.type === "SYSTEM_PURPOSE";
    let options = LEGALBASIS_OPTIONS;
    if(isIabCat) {
      options = options.filter((opt) => opt.value !== "DISCLOSURE_ONLY")
    }  
    columns.push({
      title: ({ sortOrder, sortColumn, filters }) => {
        let regionsFailedToUpdate = 0;
        dataSource.forEach((data) => {
          if(data.updateStatus[cat.id] === "fail") {
            regionsFailedToUpdate++
          }
        });
        return (
        <Flex vertical gap={12}>
          <Space direction="vertical">
            <Paragraph style={{maxWidth: 150}} ellipsis={{tooltip:{title: cat.privacyChoice ?? cat.name}, rows: 2}}>{cat.privacyChoice ?? cat.name}</Paragraph>
            <Tag color={isIabCat ? "orange" : "magenta"}> {isIabCat ? props.isNoFrameworkFlow ? "Standard" : "IAB" : "Custom"}</Tag>
          </Space>
          <Select
            onChange={(value) => handleCateogyLegalBasisChagne(cat.id, value)}
            options={options}
            style={{minWidth: 150}}
          />
          {regionsFailedToUpdate > 0 ? <Alert type="error" message={<><b>{regionsFailedToUpdate} Regions:</b> Does not support Legal Basis</>}/> : null}
        </Flex>
      )},
      width: 200,
      dataIndex: ["legalBasis", cat.id],
      render: (value, record) => {
        const isUpdateSuccess = record.updateStatus?.[cat.id] === "success";
        const isUpdateFailure = record.updateStatus?.[cat.id] === "fail";
        return (
          <Space>
            { isUpdateSuccess ? <CheckOutlined style={{color: token.colorSuccess}}/> : isUpdateFailure ? <CloseOutlined style={{color: token.colorError}}/> : null}
            <Typography.Text>{legalOptionsValueToLabel[value] ?? "Not Applicable"}</Typography.Text>
          </Space>
        )
      }
    })
  })

  return (
    <>
      <Modal
        open={props.openModal}
        title="Bulk Edit"
        okText="Save"
        onOk={handleSaveChange}
        cancelButtonProps={{
          type: "link"
        }}
        onCancel={props.closeModal}
        width={"80vw"}
      >
        <Flex vertical gap={16}>
          <Alert type="info" showIcon closable message="Note: Bulk operations will not affect the states where the privacy choice configuration is not editable."/>
          <Table
            columns={columns}
            dataSource={dataSource}
            scroll={{ x: 1000}}
            pagination={{
              position: ['bottomCenter'],
              showTotal: (total) => <div>Total Regions :{' '}{total}</div>,
              size: 'small',
              defaultPageSize: 7,
              showSizeChanger: true,
              pageSizeOptions: ['7', '10', '15', '20'],
            }}
          />
        </Flex>
      </Modal>
      {contextHolder}
    </>
  )
}

export default BulkRegionMappingModal;